<template>
    <div class="scanner">
        <v-btn  depressed class="back" @click="goBack">Go Back</v-btn>

        
        <v-btn outlined color="darkgray" @click="openCamera">{{ !isShowingCamera ? 'Scan a QR code': 'Exit QR scanning'}}</v-btn>
        <div class="camera">
            <QrcodeStream v-if="isShowingCamera" :camera="camera"  @decode="onDecode" @init="onInit"></QrcodeStream>            
        </div>


    </div>
</template>
<script>
import { QrcodeStream } from 'vue-qrcode-reader'

export default{
    name:"scanQR",
    data(){
        return{
            camera: 'auto',
            isShowingCamera:false
        }
    },
    components: {
      QrcodeStream,
    },
    methods: {
        openCamera(){
            this.isShowingCamera = !this.isShowingCamera
        },
        onDecode (decodedString) {
            console.log(decodedString)
            let queryObj = decodedString.split("?")[1]
            function parseParams(str) {
                var pieces = str.split("&"), data = {}, i, parts;
                // process each query pair
                for (i = 0; i < pieces.length; i++) {
                    parts = pieces[i].split("=");
                    if (parts.length < 2) {
                        parts.push("");
                    }
                    data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
                }
                return data;
            }
            const parseObj = parseParams(queryObj)
            let url = {
                path: "/",
                query: parseObj
            };

            this.$router.push(url);                  
        },
        async onInit (promise) {
            // show loading indicator
            try {
            const { capabilities } = await promise
            // successfully initialized
            } catch (error) {
            if (error.name === 'NotAllowedError') {
                // user denied camera access permisson
                this.$toast('Access to camera is denied')
                this.isShowingCamera= false
            } else if (error.name === 'NotFoundError') {
                // no suitable camera device installed
                this.$toast('no suitable camera device installed')
                this.isShowingCamera= false
            } else if (error.name === 'NotSupportedError') {
                // page is not served over HTTPS (or localhost)
                this.isShowingCamera= false
            } else if (error.name === 'NotReadableError') {
                // maybe camera is already in use
                this.$toast('maybe camera is already in use')
                this.isShowingCamera= false
            } else if (error.name === 'OverconstrainedError') {
                // did you requested the front camera although there is none?
                this.$toast('did you requested the front camera although there is none?')
                this.isShowingCamera= false
            } else if (error.name === 'StreamApiNotSupportedError') {
                // browser seems to be lacking features
                this.$toast('browser seems to be lacking features')
                this.isShowingCamera= false
            }
            } finally {
            // hide loading indicator
            }
        },
        goBack(){
            history.go(-1)
        }
    }
}


</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');

.scanner{
    height: 100%;
    padding: 4rem 1rem;
    display: grid;
    place-items: center;

}
.back{
    margin-bottom: 1rem;
}
.camera{
    margin-top: 2rem;
}
</style>